import { Button, Modal, Spinner } from "react-bootstrap";
import { MdCheckCircle } from "react-icons/md";

import { Typography } from '@material-ui/core';
import { useState } from 'react';
import { RiCloseCircleFill } from 'react-icons/ri';
import { Link, useHistory } from 'react-router-dom';
import { Request } from "../../../../@types/requests";
import { useStateValue } from '../../../../providers/StateProvider';
import { changeAttendant } from '../../../../services/requests';

interface ModalPermissionProps {
  open: boolean;
  onOpen: () => void;
  request: Request
}



export function ModalPermission({
  open,
  onOpen,
  request,
}: ModalPermissionProps) {
  const [ isLoading, setIsLoading ] = useState(false)
  const [{ user }] = useStateValue();
  const history = useHistory();

  const attendantName =  request?.atendente?.first_name

  const handleChangeAttendant = async () => {
    setIsLoading(true)
    try{
      await changeAttendant({
        requestId: request?.id,
        newAttendantCpf: user?.cpf,
      })
      history.push(
        `/solicitacoes/detalhes/${request?.identificador}`
      );
    } catch(err){
      console.error({err})
      
    } 
    finally {
      setIsLoading(false)
    }
  }

  return (
      <Modal show={open} onHide={onOpen}  centered>
        <Modal.Header>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Atenção     
          </Typography>
        </Modal.Header>
        <Modal.Body>
           <Typography id="modal-modal-description">
              A solicitação está sendo tratada pelo atendente
              '{attendantName}'. 
              Deseja continuar?
          </Typography>
        </Modal.Body >
        <Modal.Footer>
          {isLoading ? <Spinner animation="border" variant="primary" /> : 
            <>
              <Button variant="success" onClick={handleChangeAttendant}>
                <MdCheckCircle size={20} />
                Sim
              </Button>
              <Link to={`/solicitacoes/detalhes/${request?.identificador}`}>
                <Button  variant="danger">
                  <RiCloseCircleFill size={20} />
                  Não
                </Button>
              </Link>
            </>
            }
        </Modal.Footer>
      </Modal>
  )
}
